import { z } from "zod";

export type Brand<T, Name extends string> = T & {
  readonly __brand: Name;
};

export type CustomerId = Brand<string, "CustomerId">;
export type FacilityId = Brand<string, "FacilityId">;
/** Public Asset identifier: a UUID validated by `assetIdSchema`. */
export type AssetId = Brand<string, "AssetId">;
export type WorkOrderId = Brand<string, "WorkOrderId">;
export type WorkRequestId = Brand<string, "WorkRequestId">;

export function asCustomerId(value: string): CustomerId {
  return value as CustomerId;
}

export function asFacilityId(value: string): FacilityId {
  return value as FacilityId;
}

/**
 * Brands an asset public ID after UUID validation by `assetIdSchema`.
 */
export function asAssetId(value: string): AssetId {
  return value as AssetId;
}

export function asWorkOrderId(value: string): WorkOrderId {
  return value as WorkOrderId;
}

export function asWorkRequestId(value: string): WorkRequestId {
  return value as WorkRequestId;
}

export const customerIdSchema = z.string().min(1).transform(asCustomerId);

export const facilityIdSchema = z.string().min(1).transform(asFacilityId);

/**
 * Parses an untrusted public Asset identifier and brands the UUID result.
 */
export const assetIdSchema = z.string().uuid().transform(asAssetId);

/** Procedure detail routes use the public UUID returned by the Work API. */
export const procedureIdSchema = z.string().uuid();

export const workOrderIdSchema = z.string().uuid().transform(asWorkOrderId);

export const workRequestIdSchema = z.string().uuid().transform(asWorkRequestId);

export const customerIdSearchSchema = z
  .string()
  .trim()
  .min(1)
  .transform(asCustomerId);

export const facilityIdSearchSchema = z
  .string()
  .trim()
  .min(1)
  .transform(asFacilityId);
